import { defineCustomElement } from '@tylertech/forge-core';
import { LabelValueComponent } from './label-value';

export * from './label-value-constants';
export * from './label-value';
export * from './label-value-component-delegate';

export function defineLabelValueComponent(): void {
  defineCustomElement(LabelValueComponent);
}
